export const finishPasedInspectionFormFields = [
  {
    name: 'includePhotos',
    label: 'Include photos in report?',
    type: 'select',
    items: [
      { value: 'yes', label: 'Yes' },
      { value: 'no', label: 'No' },
    ],
    grid: {
      sm: 6,
      xs: 6,
    },
    rules: {
      required: 'This field is required.',
    },
  },
  {
    name: 'backdateInspection',
    label: 'Backdate inspection?',
    type: 'select',
    items: [
      { value: 'yes', label: 'Yes' },
      { value: 'no', label: 'No' },
    ],
    grid: {
      sm: 6,
      xs: 6,
    },
    rules: {
      required: 'This field is required.',
    },
  },
];
export const finishFailedInspectionFormFields = [
  {
    name: 'reinspectIn',
    label: 'Reinspect in',
    suffix: 'Days',
    grid: {
      sm: 7,
      xs: 7,
    },
  },
  {
    name: 'addInspectionFee',
    label: 'Add inspection fee?',
    type: 'select',
    items: [
      { value: 'yes', label: 'Yes' },
      { value: 'no', label: 'No' },
    ],
    grid: {
      sm: 6,
      xs: 6,
    },
    rules: {
      required: 'This field is required.',
    },
  },
  {
    name: 'inspectionFee',
    label: 'Inspection fee',
    type: 'number',
    grid: {
      sm: 6,
      xs: 6,
    },
  },
  {
    name: 'includePhotos',
    label: 'Include photos in report?',
    type: 'select',
    items: [
      { value: 'yes', label: 'Yes' },
      { value: 'no', label: 'No' },
    ],
    grid: {
      sm: 6,
      xs: 6,
    },
    rules: {
      required: 'This field is required.',
    },
  },
  {
    name: 'backdateInspection',
    label: 'Backdate inspection?',
    type: 'select',
    items: [
      { value: 'yes', label: 'Yes' },
      { value: 'no', label: 'No' },
    ],
    grid: {
      sm: 6,
      xs: 6,
    },
    rules: {
      required: 'This field is required.',
    },
  },
];

export const signedByInspectionFormFields = [
  {
    name: 'name',
    label: 'Name',
    grid: {
      sm: 6,
      xs: 6,
    },
    rules: {
      required: 'This field is required.',
    },
  },
  {
    name: 'title',
    label: 'Title',
    grid: {
      sm: 6,
      xs: 6,
    },
  },
  {
    name: 'businessName',
    label: 'Business name',
    grid: {
      sm: 12,
      xs: 12,
    },
  },

  {
    name: 'businessPhone',
    label: 'Business phone',
    grid: {
      sm: 6,
      xs: 6,
    },
  },
  {
    name: 'cellPhone',
    label: 'Cell phone',
    grid: {
      sm: 6,
      xs: 6,
    },
  },

  {
    name: 'emailAddress',
    label: 'Email address',
    grid: {
      sm: 12,
      xs: 12,
    },
  },
];

export const inspectionSendToFormFields = [
  {
    name: 'additionalAddress',
    label: 'Enter additional addresses',
    grid: {
      sm: 12,
      xs: 12,
    },
  },
  {
    name: 'signature',
    label:
      'By signing below I certify that I have received the violations noted in this report. I understand that these violations must be corrected as soon as possible.',
    type: 'signature',
    grid: {
      sm: 12,
      xs: 12,
    },
  },
];
